import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import Breadcrumbs from './Breadcrumbs';
// import useSpan from '../../hooks/useSpan';

// eslint-disable-next-line no-undef
const articles = window.enervent.translations.articles || 'Artikkelit';

const ArticleHeader = ({ title, categories }) => (
  <>
    <Row>
      <Col
        xs={{
          offset: 2,
          span: 20,
        }}
        md={{ offset: 3, span: 16 }}
      >
        <div className="article-header">
          <Breadcrumbs title={title} parent={{ link: '#', title: articles }} />
          <div className="article-header__categories">
            {Array.isArray(categories) &&
              categories.map((category) => (
                <a
                  className={classNames('article-header__category', {
                    'article-header__category--active': category.active,
                  })}
                  href={category.url}
                  key={category.name}
                >
                  {category.name}
                </a>
              ))}
          </div>
        </div>
      </Col>
    </Row>
  </>
);

ArticleHeader.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      active: PropTypes.bool,
      url: PropTypes.string,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
};

export default ArticleHeader;
